import api from '../../services/api';

const urlBase = '/empresas';

export default {
	listar: () => api.get(urlBase),

	criar: (data) => api.post(urlBase, data),

	atualizar: (empresaId, data) => api.put(`${urlBase}/${empresaId}`, data),

	excluir: (empresaId) => api.delete(`${urlBase}/${empresaId}`),
};